export default __webpack_public_path__ + "static/media/exchange.fe43a3ce.svg";